import * as types from './actionTypes';

export const setUserProfile = (userProfile) => ({
  type: types.SET_PROFILE,
  userProfile
});
